function bindRecurrentDonationEventListener() {
  document.addEventListener("DOMContentLoaded", function(even) {
    var c = document.querySelector(".recurrent-donation-cancel .cancel");

    c.addEventListener("click", function(event) {
      event.preventDefault();
      c.style="cursor: wait";

      $.ajax(c.href, {
        method: "POST",
        success: function(data, status) {
          if (status == 'success') {
            alert("Płatność cykliczna została anulowana.");
            history.go(0);
          }
        },
        error: function(data, status) {
          alert("wystąpił błąd ("+status+"). Prosże zgłoś go do kontakt@akcjademokracja.pl");
        }
      });
    });
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindRecurrentDonationEventListener;